import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';

import { DxTreeViewModule, DxButtonModule,DxListModule, DxLoadPanelModule, DxFileUploaderModule, DxAutocompleteModule, DxNumberBoxModule, DxTabPanelModule, DxTextAreaModule, DxCheckBoxModule,DxAccordionModule, DxRadioGroupModule, DxTagBoxModule, DxScrollViewModule, DxTextBoxModule, DxDataGridModule, DxPopupModule, DxSelectBoxModule, DxDateBoxModule } from "devextreme-angular";

// import { EditPartsComponent } from 'src/app/pages/inventory/parts/edit-parts/edit-parts.component';
import { NewPartComponent } from 'src/app/pages/inventory/parts/new-part/new-part.component';
import { SharedDatagridModule } from 'src/app/shared/shared-datagrid/shared-datagrid.module';
import { ProjectAttachedDocumentModule } from 'src/app/shared/project-attached-document/project-attached-document.module';
import { VendorAlpsPopupModule } from '../../vendors/vendor-alps-popup/vendor-alps-popup.module';
// import { TestModule } from 'src/app/pages/test/test.module';
@NgModule({
  declarations: [
    NewPartComponent,
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DashboardModule,
    DxTreeViewModule,
    DxButtonModule,
    DxTagBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxDataGridModule,
    DxAutocompleteModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxRadioGroupModule,
    DxTabPanelModule,
    DxAccordionModule,
    DxCheckBoxModule,
    DxLoadPanelModule,
    DxTextAreaModule,
    DxNumberBoxModule,
    DxFileUploaderModule,
    ProjectAttachedDocumentModule,
    DxListModule,
    SharedDatagridModule,
    DxRadioGroupModule,
    VendorAlpsPopupModule,
    // TestModule
  ], exports:[NewPartComponent]
})
export class NewPartsModule { }
